export default "__VITE_ASSET__CHPcBRVt__"